import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import { Flex } from 'reflexbox'

import GpuSku from 'components/custom/NotebookGpuSku/index'

import styles from './styles.scss'

const ProductDetails = props => {
  const {
    segment,
    line,
    family,
    platform,
    sku,
    brand,
    gpuSku,
    devIdA,
    devIdB,
    architecture
  } = props
  return (
    <Flex column styleName='productDetailContainer'>
      <h5>{sku}</h5>
      <span>{segment}</span>
      <span>{brand}</span>
      <span>{devIdA}</span>
      <span>{devIdB}</span>
      <GpuSku
        segment={segment}
        gpuSku={gpuSku}
      />
      <span>{architecture}</span>
    </Flex>
  )
}

ProductDetails.propTypes = {
  segment: PropTypes.string.isRequired,
  line: PropTypes.string.isRequired,
  family: PropTypes.string.isRequired,
  platform: PropTypes.string.isRequired,
  sku: PropTypes.string.isRequired,
  brand: PropTypes.string.isRequired,
  gpuSku: PropTypes.string.isRequired,
  architecture: PropTypes.string.isRequired,
}

ProductDetails.defaultProps = {
  segment: '',
  line: '',
  family: '',
  platform: '',
  sku: '',
  brand: '',
  gpuSku: '',
  architecture: '',
}

export default CSSModules(ProductDetails, styles)
